<script setup>
import locationMap from "@/assets/images/pages/location/gamania-location.png";

const props = defineProps({
    title: {
        type: [String, Array],
        required: true,
    },
});

const { locale } = useI18n();
const textRef = ref(null);

onMounted(async () => {
    await nextTick();
    textRef.value.animate({ delay: 2 });
});
</script>
<template>
    <section class="hero-wrapper">
        <div class="flex h-full w-full">
            <BaseFormatText2
                type="h1"
                ref="textRef"
                :text="title"
                :brClass="locale === 'zh' ? 'sm:hidden' : ''"
                class="hero-title slt-h2 whitespace-pre-wrap"
            />
        </div>

        <div class="absolute bottom-0 left-0 h-full w-full">
            <div
                class="hero-map"
                :style="{ backgroundImage: `url(${locationMap})` }"
            ></div>

            <figure
                class="float-updown sticky bottom-9 z-30 ml-[44%] mt-8 flex flex-col items-center justify-start sm:bottom-[100px] sm:ml-[40%] md:ml-[36%] lg:bottom-7 lg:ml-[48%] xl:ml-[44%]"
            >
                <div
                    class="relative z-30 -mb-[35px] flex w-[85.18px] items-center justify-center sm:-mb-[55px] sm:w-[126.52px] lg:w-[145.49px]"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="size-full"
                        viewBox="0 0 147 185"
                        fill="none"
                    >
                        <path
                            d="M76.1509 183.609C89.2276 171.604 146.243 116.726 146.243 72.54C146.243 32.4773 113.675 0 73.5004 0C33.3258 0 0.757812 32.4773 0.757812 72.54C0.757812 122.869 57.3904 172.715 70.7165 183.748C72.3365 185.089 74.6016 185.031 76.1509 183.609Z"
                            fill="#FF6400"
                        />
                    </svg>
                    <div
                        class="absolute left-1/2 top-[9px] size-[66px] -translate-x-1/2 rounded-full bg-base-bgGrey p-[3px] sm:top-[12px] sm:size-[100px] sm:p-[5px] lg:top-[13px] lg:size-[116px] lg:p-[6px]"
                    >
                        <GamaGlobeLottie />
                    </div>
                </div>
                <CustomLocationRipple
                    class="lg:-w-[404.06px] z-20 h-auto w-[236.6px] sm:w-[351.4px]"
                />
            </figure>
        </div>
    </section>
</template>

<style scoped>
.hero-wrapper {
    @apply relative mx-auto h-[462px] w-full max-w-[var(--slt-container-width)] overflow-hidden bg-base-silver lg:h-[400px] lg:w-[94.70vw] lg:rounded-2xl;
}

.hero-title {
    @apply z-40 mx-auto mt-[104px] w-[92.11vw] max-w-[var(--slt-container-width-sm)] pt-2 sm:mb-0 sm:w-[89.71vw] sm:self-end sm:py-10 lg:my-0 lg:w-[78.35%] lg:max-w-none lg:self-center;
}

.hero-map {
    @apply relative h-full w-full bg-[length:auto_130%]
    bg-[position:60%_2%] bg-no-repeat opacity-20 
    sm:bg-[length:auto_105%] sm:bg-[position:58%_60%] 
    lg:bg-[length:2530px] lg:bg-[position:52%_8%];
}

.hero-map::after {
    content: "";
    @apply absolute bottom-0 left-0 h-full w-full bg-[linear-gradient(180deg,rgba(233,236,242,0)_0%,#E9ECF2_100%)] sm:h-[70%]
    lg:h-full 
    lg:bg-[linear-gradient(270deg,rgba(233,236,242,0)_0%,#E9ECF2_100%)];
}

/* 地標動畫 */
.float-updown {
    animation:
        float-updown 4s ease-in-out 2s infinite,
        float-down-once 1s ease-out 2s;
}

@keyframes float-updown {
    0%,
    100% {
        transform: translateY(0);
    }
    50% {
        transform: translateY(-6px);
    }
}

@keyframes float-down-once {
    0% {
        transform: translateY(-100%);
    }
    100% {
        transform: translateY(0);
    }
}
</style>
